import React from 'react';
import { button } from 'react-validation';

export const Button = button(({hasErrors, disableOnError, ...props}) => {
  return (
    <button {...props} disabled={disableOnError && hasErrors} />
  )
});
